export default {
  data() {
    return {
      // exchangeRates: {}, // { USD: 1, EUR: 0.92, ... }
      // exchangeRatesLoaded: false,
      // cachedBaseCurrency: 'GBP',
    };
  },
  computed: {
    baseCurrency() {
      return this.$currency.state.baseCurrency
    },
    exchangeRates() {
      return this.$currency.state.exchangeRates
    }
  },
  methods: {
    async loadExchangeRates(base = 'GBP') {
        // console.log("base");
        // console.log(base);
        await this.$currency.init(base);

        // const cacheKey = `exchangeRatesCache_${base}`;
        // const cacheExpiryMs = 1000 * 60 * 60; // 1 hour cache validity

        // try {
        //     // Check localStorage cache
        //     const cachedData = localStorage.getItem(cacheKey);
        //     if (cachedData) {
        //         const parsed = JSON.parse(cachedData);
        //         const now = Date.now();

        //         if (parsed.timestamp && (now - parsed.timestamp) < cacheExpiryMs) {
        //             // Cache is valid, use it
        //             this.exchangeRates = parsed.rates;
        //             this.cachedBaseCurrency = base;
        //             return this.exchangeRates;
        //         }
        //     }

        //     // Cache missing or expired, fetch from API
        //     const response = await axios.get('/api/assetflow/exchange_rates/getRates', {
        //         params: { base }
        //     });

        //     if (response.data && response.data.rates) {
        //         this.exchangeRates = response.data.rates;
        //         this.cachedBaseCurrency = base;

        //         // Save to localStorage cache with timestamp
        //         localStorage.setItem(
        //             cacheKey,
        //             JSON.stringify({
        //                 rates: this.exchangeRates,
        //                 timestamp: Date.now()
        //             })
        //         );

        //         return this.exchangeRates;
        //     }
        //     throw new Error('Invalid exchange rates response');
        // } catch (error) {
        //     console.error('Error loading exchange rates:', error);
        //     // Optionally: fallback or clear cache here
        //     return null;
        // }
    },

    convertValue(value, toCurrency) {
      return this.$currency.convert(value, (toCurrency+"").toUpperCase());
    },

    formatCurrency(value, currencyCode) {
      try {
        const code = currencyCode && isNaN(Number(currencyCode))
          ? String(currencyCode).toUpperCase()
          : 'GBP';
        const formatter = new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: code,
        });
        return formatter.format(value);
      } catch (e) {
        // fallback if the currency code is invalid
        console.log(`Invalid currency code: ${currencyCode}`, e);
        return value != null ? Number(value).toFixed(2) : '';
      }
    },
  }
};
